// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDb8dBUsu4VWvgCn3yHt3eHvCFTPwLCw5M",
  authDomain: "resaller-80d96.firebaseapp.com",
  projectId: "resaller-80d96",
  storageBucket: "resaller-80d96.appspot.com",
  messagingSenderId: "196576983160",
  appId: "1:196576983160:web:7088675150cfb46aef158d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;